(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-gift-section"] && !Shopify.designMode) return;
  try {
    
  function addToCart(elem, type) {
    document.querySelectorAll(elem).forEach(function (elem) {
      elem.onclick = function (e) {
        e.preventDefault();

        // Get the button and loader elements
        var buttonElement = this.querySelector('.button');
        var loaderElement = this.querySelector('.loader');

        // Hide the button and show the loader
        buttonElement.style.display = 'none';
        loaderElement.classList.remove('hide');

        let formData = {
          items: [
            {
              id: elem.getAttribute('data-variant-id'),
              quantity: 1,
            },
          ],
        };
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            if (type == 'checkout') {
              window.location.href = '/checkout';
            } else {
              theme.Cart.prototype._onProductAdded();
            }
          })
          .finally(() => {
            // Show the button and hide the loader
            buttonElement.style.display = 'flex';
            loaderElement.classList.add('hide');
          });
      };
    });
  }

  if (document.querySelectorAll('.btn--addtocart').length > 0) {
    addToCart('.btn--addtocart', '');
  }

  if (document.querySelectorAll('.btn--checkoutproduct').length > 0) {
    addToCart('.btn--checkoutproduct', 'checkout');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-disaster-page-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.disaster__items_swiper')){
        var sliderEnabled = document.querySelector('.disaster__items_swiper').getAttribute('data-slider-enabled');
        var visibleSlides = parseInt(document.querySelector('.disaster__items_swiper').getAttribute('data-slides'));
        if (sliderEnabled == 'true' && window.innerWidth >  749) {
            var swiper = new Swiper('.disaster__items_swiper', {
                slidesPerView: 'auto',
                spaceBetween: 15,
                navigation: {
                    nextEl: document.querySelector('.disaster__items_swiper .swiper-button-next'),
                    prevEl: document.querySelector('.disaster__items_swiper .swiper-button-prev'),
                },
                breakpoints: {
                    1200: {
                    slidesPerView: visibleSlides,
                    spaceBetween: 15,
                    },
                    992: {
                    slidesPerView: visibleSlides,
                    spaceBetween: 15,
                    },
                    768: {
                    slidesPerView: 'auto'
                    }
                }
            });

            if(window.innerWidth > 749 && document.querySelectorAll('.disaster__items_swiper .swiper-slide').length <= visibleSlides){
                document.querySelector('.disaster__items_swiper .swiper-button-next').style.display = 'none';
                document.querySelector('.disaster__items_swiper .swiper-button-prev').style.display = 'none';
            }
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_box-content"] && !Shopify.designMode) return;
  try {
    
  let swiperInstances = []; // Array to hold swiper instances

  function initCustSliderImageContent() {
    // Check if the window width is less than or equal to 749px (mobile)
    if (window.innerWidth <= 749) {
      var sliders = document.querySelectorAll('[data-js-cust-box-content-slider]');
      if (!sliders.length) return; // Exit if no sliders are found

      sliders.forEach(function (slider, index) {
        if (!swiperInstances[index]) { // Check if swiper instance already exists
          swiperInstances[index] = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
          });
        }
      });
    } else {
      // Destroy swiper instances on desktop
      swiperInstances.forEach(function (swiper) {
        if (swiper) {
          swiper.destroy(true, true); // Destroy the swiper instance
        }
      });
      swiperInstances = []; // Clear the array
    }
  }

  function initScrollToSection() {
    var scrollPosEnd = 0;
    document.querySelectorAll('.cust-box-content__button').forEach(function(element){
      var section_id = element.getAttribute('href');

      // Only add click event if href starts with "#"
      if (section_id.startsWith("#")) {
        element.onclick = function(e){
          e.preventDefault();
          var sectionElem = document.querySelector(section_id);
          if(sectionElem) {
            var scrollDiv;
            scrollDiv = sectionElem.offsetTop;

            scrollPosEnd = scrollDiv - 100;
            window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
          }
        };
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustSliderImageContent();
    initScrollToSection();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustSliderImageContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const items = document.querySelectorAll('[data-item]');
      items.forEach(item => {
        item.addEventListener('click', function() {
          this.classList.toggle('active');
          items.forEach(otherItem => {
            if (otherItem !== this) {
              otherItem.classList.remove('active');
            }
          });
        });
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_rich-card"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var sliderEnabled = document.querySelector('.product__items_swiper').getAttribute('data-slider-enabled');
  var visibleSlides = parseInt(document.querySelector('.product__items_swiper').getAttribute('data-slides'));
  if (sliderEnabled == 'true') {
    var swiper = new Swiper('.product__items_swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: document.querySelector('.product__items_swiper .swiper-button-next'),
        prevEl: document.querySelector('.product__items_swiper .swiper-button-prev'),
      },
      breakpoints: {
        1200: {
          slidesPerView: visibleSlides,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: visibleSlides,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 'auto'
        }
      }
    });

    if(window.innerWidth > 749 && document.querySelectorAll('.product__items_swiper .swiper-slide').length <= visibleSlides){
      document.querySelector('.product__items_swiper .swiper-button-next').style.display = 'none';
      document.querySelector('.product__items_swiper .swiper-button-prev').style.display = 'none';
    }
    window.addEventListener('resize', function() {
      if(window.innerWidth > 749 && document.querySelectorAll('.product__items_swiper .swiper-slide').length <= visibleSlides){
        document.querySelector('.product__items_swiper .swiper-button-next').style.display = 'none';
        document.querySelector('.product__items_swiper .swiper-button-prev').style.display = 'none';
      } else {
        document.querySelector('.product__items_swiper .swiper-button-next').style.display = 'block';
        document.querySelector('.product__items_swiper .swiper-button-prev').style.display = 'block';
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_slider-content"] && !Shopify.designMode) return;
  try {
    
  let swiperInstances = []; // Array to hold swiper instances

  function initCustSliderImageContent() {
    // Check if the window width is less than or equal to 749px (mobile)
    if (window.innerWidth <= 749) {
      var sliders = document.querySelectorAll('[data-js-cust-slider-content-slider]');
      if (!sliders.length) return; // Exit if no sliders are found

      sliders.forEach(function (slider, index) {
        if (!swiperInstances[index]) { // Check if swiper instance already exists
          swiperInstances[index] = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
          });
        }
      });
    } else {
      // Destroy swiper instances on desktop
      swiperInstances.forEach(function (swiper) {
        if (swiper) {
          swiper.destroy(true, true); // Destroy the swiper instance
        }
      });
      swiperInstances = []; // Clear the array
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustSliderImageContent();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustSliderImageContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_tabs-content-with-table-2"] && !Shopify.designMode) return;
  try {
    
    function initCustTabsContent() {
      const tabLinks = document.querySelectorAll(".cust-tabs-content-table__tab-link");
      const tabContents = document.querySelectorAll(".cust-tabs-content-table__content");
  
      tabLinks.forEach((link, index) => {
        link.addEventListener("click", () => {
          tabLinks.forEach((link2) => link2.parentNode.classList.remove("active")),
          tabContents.forEach((content) => content.classList.remove("active")),
          link.parentNode.classList.add("active"),
          tabContents[index].classList.add("active");
        });
      });
    }
  
    document.addEventListener("DOMContentLoaded", function() {
      initCustTabsContent();
  
      // Add event listener for window resize
      window.addEventListener("resize", function() {
        // Re-initialize the slider on resize
        initCustTabsContent();
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_tabs-content-with-table"] && !Shopify.designMode) return;
  try {
    
  function initCustTabsContent() {
    const tabLinks = document.querySelectorAll(".cust-tabs-content-table__tab-link");
    const tabContents = document.querySelectorAll(".cust-tabs-content-table__content");

    tabLinks.forEach((link, index) => {
      link.addEventListener("click", () => {
        tabLinks.forEach((link2) => link2.parentNode.classList.remove("active")),
        tabContents.forEach((content) => content.classList.remove("active")),
        link.parentNode.classList.add("active"),
        tabContents[index].classList.add("active");
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustTabsContent();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustTabsContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_yt-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const thumbnails = document.querySelectorAll('.cust-yt-video__thumbnail');

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (event) {
        const iframeWrapper = thumbnail.parentElement.querySelector('.cust-yt-video__iframe-wrapper');

        if (iframeWrapper) {
          iframeWrapper.classList.remove('hidden');
          void iframeWrapper.offsetWidth;
        }
      });
    });

    const closeButtons = document.querySelectorAll('.close-btn');

    closeButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function (event) {
        const iframeWrapper = closeButton.parentElement;
        const iframe = iframeWrapper.querySelector('.cust-yt-video__iframe');

        if (iframeWrapper) {
          iframeWrapper.classList.add('hidden');
          if (iframe) {
            const src = iframe.src;
            iframe.src = src;
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["disaster-2025-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    var flickityInstance = new Flickity('.disaster-slideshow-section .slideshow-wrapper', {
        cellAlign: "left",
        pageDots: true,
        contain: true,
        watchCSS: true,
        wrapAround: true,
        prevNextButtons: false,
        imagesLoaded: true
    });

    document.querySelector('.disaster-slideshow-section .slider-btn-prev').onclick = function(){
        flickityInstance.previous();
    }

    document.querySelector('.disaster-slideshow-section .slider-btn-next').onclick = function(){
        flickityInstance.next();
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["disaster-page-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
if(document.querySelector('.swiper.products_wrapper')){
    var swiper = new Swiper('.products_wrapper', {
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1200: {
                slidesPerView: 4,
                spaceBetween: 12,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 'auto'
            }
        }
    });
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m4-member-custom-section"] && !Shopify.designMode) return;
  try {
    
      if(document.querySelectorAll('.open_info').length > 0 && window.innerWidth < 768){
        document.querySelectorAll('.open_info').forEach(function(element){
            var left_offset = element.offsetLeft;
            var top_offset = element.offsetTop;
            console.log(left_offset);
            console.log(top_offset);
            if(left_offset > window.innerWidth / 2){
              element.querySelector('.info_content').classList.add('align_right');
              element.querySelector('.info_content').style.setProperty('--right-offset', left_offset - 230 + 'px');
            }
            element.querySelector('.info_content').style.setProperty('--left-offset', left_offset + 'px');
            element.querySelector('.info_content').style.setProperty('--top-offset', top_offset + 'px');
        });
      }
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m5-outdoor-gift-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    if(window.innerWidth < 750){
      var swiper = new Swiper('.outdoor-image-block-wrapper', {
          slidesPerView: 1,
          pagination: {
              el: '.swiper-dots',
              clickable: true,
          },
          navigation: {
              nextEl: '.swiper-btn-next',
              prevEl: '.swiper-btn-prev',
          },
      });
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-product-with-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.pdp-products-grid-section').forEach(function(section) {
      let buttonsHeight = 0;
      section.querySelectorAll('.pdp-grid-section__product-btn-wrap').forEach(function(elem) {
        if (elem.offsetHeight > buttonsHeight) {
          buttonsHeight = elem.offsetHeight;
        }
      });
      section.style.setProperty('--buttons-height', buttonsHeight + 'px');
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video-icon-text-gallery"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const thumbnails = document.querySelectorAll('.pdp-video-icon-text-gallery-item .pdp-video-thumbnail');
      const videoOverlay = document.querySelector('.pdp-video__iframe-overlay');

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function (event) {
          const iframeWrapper = thumbnail.parentElement.querySelector('.pdp-video__iframe-wrapper');

          if (iframeWrapper) {
            videoOverlay.innerHTML = iframeWrapper.innerHTML;
            videoOverlay.classList.remove('hidden');
          }
        });
      });

      videoOverlay.addEventListener('click', function (event) {
        if (
          event.target.classList.contains('close-btn') ||
          (event.target.parentElement && event.target.parentElement.classList.contains('close-btn'))
        ) {
          videoOverlay.classList.add('hidden');
          videoOverlay.innerHTML = '';
        }

        if (
          event.target.classList.contains('video-play-btn') ||
          event.target.closest('.video-play-btn')
        ) {
          event.target.closest('.pdp-video__iframe-overlay').querySelector('video').play();
          event.target.closest('.pdp-video__iframe-overlay').querySelector('.video-play-btn').hide();
        }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-youtube-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const thumbnails = document.querySelectorAll('.pdp-youtube-video .pdp-video-thumbnail');
      const videoOverlay = document.querySelector('.pdp-yt-video__iframe-overlay');

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function (event) {
          const iframeWrapper = thumbnail.parentElement.querySelector('.pdp-yt-video__iframe-wrapper');

          if (iframeWrapper) {
            videoOverlay.innerHTML = iframeWrapper.innerHTML;
            videoOverlay.classList.remove('hidden');
          }
        });
      });

      videoOverlay.addEventListener('click', function (event) {
        if (
          event.target.classList.contains('close-btn') ||
          (event.target.parentElement && event.target.parentElement.classList.contains('close-btn'))
        ) {
          videoOverlay.classList.add('hidden');
          videoOverlay.innerHTML = '';
        }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-image-with-text"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const popup = document.querySelectorAll('.pillar-image-text-block-btn');
        popup.forEach(function(item) {
            item.addEventListener('click', function() {
                const target = this.dataset.target;
                const popup = document.querySelector('.' + target);
                popup.classList.add('active');
            });
        });

        const popupWrap = document.querySelectorAll('.pillar-image-text-popup');
        popupWrap.forEach(function(item) {
            item.addEventListener('click', function() {
                if(!this.closest('.pillar-image-text-popup-inner')){
                    this.classList.remove('active');
                }
            });
        });

        const popupClose = document.querySelectorAll('.pillar-image-text-popup-close');
        popupClose.forEach(function(item) {
            item.addEventListener('click', function() {
                this.closest('.pillar-image-text-popup').classList.remove('active');
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-lp-scenario"] && !Shopify.designMode) return;
  try {
    
  function initializeMobileSwiper(elem) {
    var swiperContainer = document.querySelector(elem);

    if (swiperContainer.classList.contains('swiper-initialized')) {
      var existingSwiper = swiperContainer.swiper;
      if (existingSwiper) {
        existingSwiper.destroy();
      }
      swiperContainer.classList.remove('swiper-initialized');
    }

    if (window.innerWidth < 750) {
      var swiper = new Swiper(swiperContainer, {
        freeMode: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
        scrollbar: {
          el: swiperContainer.parentElement.querySelector('.swiper-scrollbar')
        },
        breakpoints: {
          768: {
            spaceBetween: 26,
          },
        },
      });

      swiperContainer.swiper = swiper;
      swiperContainer.classList.add('swiper-initialized');
    }
  }

  window.addEventListener('DOMContentLoaded', function () {
    if(document.querySelectorAll('.scenario-block').length > 0){
      initializeMobileSwiper('.scenario-blocks-swiper');
      window.addEventListener('resize', function () {
        initializeMobileSwiper('.scenario-blocks-swiper');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-lp-sticky-bar"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const targetSection = document.querySelector('.pillar-lp-sticky-bar-section');
      let targetSectionPosition;
      const anchors = targetSection.querySelectorAll('.pillar-lp-sticky-bar-section__item-link');
      let placeholder = document.querySelector('.sticky-placeholder');
      const shopifySections = document.querySelectorAll('.shopify-section');
      let lastActive = null;

      function scrollStickyBarToCenterActiveTab() {
        const activeTab = document.querySelector('.pillar-lp-sticky-bar-section__item-link.active');
        if (activeTab) {
          const stickyBarWrapper = document.querySelector('.pillar-lp-sticky-bar-section__inner');
          const activeTabLeftOffset = activeTab.offsetLeft;
          const activeTabWidth = activeTab.offsetWidth;
          const stickyBarWidth = stickyBarWrapper.offsetWidth;
          const centerPosition = activeTabLeftOffset - (stickyBarWidth / 2) + (activeTabWidth / 2);

          stickyBarWrapper.scrollTo({
            left: centerPosition,
            behavior: 'smooth'
          });
        }
      }

      anchors.forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
          event.preventDefault();

          const targetDataId = anchor.getAttribute('href');
          const targetChild = document.querySelector(targetDataId);

          console.log(targetChild);
          if (targetChild) {
            document.querySelector(".pillar-lp-sticky-bar-section").classList.add("anchor-clicked");
            anchors.forEach((a) => a.classList.remove('active'));
            anchor.classList.add('active');
            window.scrollTo({
              top: targetChild.offsetTop,
              behavior: 'smooth'
            });

            setTimeout(function(){
              document.querySelector(".pillar-lp-sticky-bar-section").classList.remove("anchor-clicked");
            }, 2000);
          }
        });
      });

      function updateStickySection() {
        targetSectionPosition = placeholder.getBoundingClientRect().top + window.pageYOffset;
        handleScroll();
      }

      function handleScroll() {
        const scrollPosition = window.pageYOffset;
        const totalHeight = targetSectionPosition;

        // Sticky logic
        if (scrollPosition > totalHeight) {
          placeholder.style.height = `${targetSection.offsetHeight}px`;
          targetSection.classList.add('sticky');
        } else {
          placeholder.style.height = '0';
          targetSection.classList.remove('sticky');
        }

        if (document.querySelector(".pillar-lp-sticky-bar-section").classList.contains("anchor-clicked") == false) {
          document.querySelectorAll(".pillar-lp-sticky-bar-section__item-link").forEach(function (e) {
            var section_id = e.getAttribute("href");
            var refElement = document.querySelector(section_id);
            if (refElement) {
              var section_top = refElement.getBoundingClientRect().top + window.pageYOffset;
              if (scrollPosition >= section_top) {
                anchors.forEach((a) => a.classList.remove('active'));
                e.classList.add('active');
              } else {
                e.classList.remove('active');
              }

              scrollStickyBarToCenterActiveTab();
            }
          });
        }
      }

      updateStickySection();
      window.addEventListener('resize', updateStickySection);
      window.addEventListener('scroll', handleScroll);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-generator"]) return;
  try {
    
    const capSwiper = new Swiper('.capacity-swiper-container', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    const swiper = new Swiper('.river-series-swiper-container', {
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
            pagination: {
            el: '.swiper-pagination',
        },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-series-collections"]) return;
  try {
    
        const swiper = new Swiper('.swiper', {
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
            },
                pagination: {
                el: '.swiper-pagination',
            },
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar_panel_bundle_1"] && !Shopify.designMode) return;
  try {
    


window.addEventListener("scroll",()=>{
	let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    let offsetTop = document.querySelector('#searchBar').offsetTop;
    if (scrollTop > offsetTop) {
         document.querySelector('#searchBar').style.position="fixed";
         document.querySelector('#searchBar').style.top="0";
    } else {
         document.querySelector('#searchBar').style.position="";
         document.querySelector('#searchBar').style.top="";
    }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar_panel_bundle_4"] && !Shopify.designMode) return;
  try {
    


var centeredSlides=false;
var spaceBetween=30;
var freeMode=true;
if (screen.width < 768) {

   centeredSlides=true;
   spaceBetween=20;
   freeMode = false;
  }

  console.log(Swiper)

 var h_feature_swiper = new Swiper('.h-feature-swiper-container', {
    centeredSlides:centeredSlides,
    slidesPerView: 'auto',
    spaceBetween: spaceBetween,
    freeMode: freeMode,
    autoplay:true,
    pagination: {
      clickable: true,
    },

  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar_panel_bundle_5"] && !Shopify.designMode) return;
  try {
    


$('.flipper').click(function(){



  if($(this).hasClass("rotate")){
　　　　　　　　$(this).removeClass("rotate").css('transform','rotateY(0deg)')
　　　　　}else{
　　　　　　$(this).addClass("rotate").css('transform','rotateY(180deg)')
　　　　　}
})



  } catch(e) { console.error(e); }
})();
})();
